import React from "react";

import { CreditReviewPages, CreditReviewTabs } from "globalConstants";
import {
	applicationListPermissionSet,
	creditReviewPermissionSet,
	equipmentOrderingPermissionSet,
	installationPermissionSet,
	merchantPermissionSet,
	permissionList,
	systemSetupPermissionSet,
	underwritingQueuePermissionSet,
	viewBoardingPagePermissionSet,
	viewResidualsTabSet,
} from "helpers";

import { ReactComponent as ApplicationListIcon } from "static/images/sidebar_icons/application_list.svg";
// import { ReactComponent as ChargebacksIcon } from "static/images/sidebar_icons/chargebacks.svg";
import { ReactComponent as BoardingQueueIcon } from "static/images/sidebar_icons/boarding.svg";
import { ReactComponent as CreditReviewIcon } from "static/images/sidebar_icons/credit_review.svg";
import { ReactComponent as InstallationIcon } from "static/images/sidebar_icons/installation.svg";
import { ReactComponent as MerchantListIcon } from "static/images/sidebar_icons/merchant_list.svg";
import { ReactComponent as ResidualsIcon } from "static/images/sidebar_icons/residuals.svg";
import { ReactComponent as RiskListIcon } from "static/images/sidebar_icons/risk_list.svg";
// import { ReactComponent as ReportsIcon } from "static/images/sidebar_icons/report.svg";
// import { ReactComponent as CommissionsIcon } from "static/images/sidebar_icons/commissions.svg";
import { ReactComponent as SettingsIcon } from "static/images/sidebar_icons/settings.svg";
import { ReactComponent as TerminalSolutionIcon } from "static/images/sidebar_icons/terminal_solution.svg";
import { ReactComponent as TidIcon } from "static/images/sidebar_icons/tid_request.svg";
import { ReactComponent as UnderwritingIcon } from "static/images/sidebar_icons/underwriting.svg";

export const getSideMenuItems = () => [
	{
		label: "Application List",
		to: "/applications/all",
		rootPath: "/applications",
		icon: <ApplicationListIcon width="22" />,
		requiredPermissions: applicationListPermissionSet,
	},
	{
		label: "Underwriting",
		to: "/underwriting/unassigned",
		rootPath: "/underwriting",
		icon: <UnderwritingIcon width="22" />,
		requiredPermissions: underwritingQueuePermissionSet,
	},

	{
		label: `${CreditReviewPages.CreditReview.displayName}`,
		to: `/${CreditReviewPages.CreditReview.name}/${CreditReviewTabs.AllMerchants.name}`,
		rootPath: `/${CreditReviewPages.CreditReview.name}`,
		icon: <CreditReviewIcon width="24" />,
		requiredPermissions: creditReviewPermissionSet,
	},
	// {
	// 	label: `${ChargebacksPages.Chargebacks.displayName}`,
	// 	to: `/${ChargebacksPages.ChargebacksQueue.name}/${ChargebacksTabs.AllMerchants.name}`,
	// 	rootPath: `/${ChargebacksPages.ChargebacksQueue.name}`,
	// 	icon: <ChargebacksIcon width="30" />,
	// 	requiredPermissions: [permissionList.PeriodicCreditReview],
	// },
	{
		label: "Boarding Queue",
		to: "/boarding-queue/unassigned",
		rootPath: "/boarding-queue",
		icon: <BoardingQueueIcon width="22" />,
		requiredPermissions: viewBoardingPagePermissionSet,
	},
	{
		label: "Tid & Equipment",
		to: "/tid-request-equipment-queue/unassigned",
		rootPath: "/tid-request-equipment-queue",
		icon: <TidIcon width="26" height="17" />,
		requiredPermissions: equipmentOrderingPermissionSet,
	},
	{
		label: "Installation",
		to: "/installation-queue/unassigned",
		rootPath: "/installation",
		icon: <InstallationIcon width="26" height="20" />,
		requiredPermissions: installationPermissionSet,
	},
	{
		label: "Merchant List",
		to: "/merchant/list",
		rootPath: "/merchant",
		icon: <MerchantListIcon width="26" />,
		requiredPermissions: merchantPermissionSet,
	},
	{
		label: "Terminal Solution",
		to: "/terminal-solution-queue/all-solutions",
		rootPath: "/terminal-solution-queue",
		icon: <TerminalSolutionIcon width="26" />,
		requiredPermissions: merchantPermissionSet,
	},
	{
		label: "Risk Monitoring",
		to: "/risk/ach-rejects",
		rootPath: "/risk",
		icon: <RiskListIcon width="26" />,
		requiredPermissions: permissionList.RiskTickets,
	},
	{
		label: "Residuals",
		to: "/residuals/source-files",
		rootPath: "/residuals",
		icon: <ResidualsIcon width="26" />,
		requiredPermissions: viewResidualsTabSet,
	},
	// "Reports" was hidden from the side menu in scope of RC-10010
	// {
	// 	label: "Reports",
	// 	icon: <ReportsIcon width="26" />,
	// 	to: "/reports",
	// 	rootPath: "/reports",
	// 	requiredPermissions: false,
	// },
	//TODO: unhide during SaaS Commissions implementation
	// {
	// 	label: CommissionsPages.Commissions.displayName,
	// 	to: `/${CommissionsPages.Commissions.name}/${CommissionsTabs.SourceFiles.name}`,
	// 	rootPath: `/${CommissionsPages.Commissions.name}`,
	// 	icon: <CommissionsIcon width="26" />,
	// 	requiredPermissions: false,
	// },
	{
		label: "System Setup",
		to: "/system-setup",
		rootPath: "/system-setup",
		icon: <SettingsIcon />,
		requiredPermissions: systemSetupPermissionSet,
	},
];
